import order from "../../state/order";
import BaseApi from "../baseApi";


export default class DepartmentResourceRelationApi extends BaseApi {
    async get(departmentId: string): Promise<AnydayQRCode[]> {
        const url = `/api/Anyday/qrcodes/${departmentId}`;
        return await this.fetchGet(url);
    }

    async upset(anyday: AnydayQRCode): Promise<AnydayQRCode> {
        const url = `/api/Anyday/qrcodes`;
        return await this.fetchPost(url, anyday);
    }

    async delete(id: string): Promise<void> {
        const url = `/api/Anyday/qrcodes/${id}`;
        return await this.fetchDelete(url);
    }

    async payment(order: Order, anydayQRCode: string): Promise<string> {
        const url = `/api/Anyday/payment/${anydayQRCode}`;
        return await this.fetchPost(url, order);
    }

     async order(orderid: string): Promise<OrderAnyday | null> {
        const url = `/api/Anyday/order/${orderid}`;
        return await this.fetchGet(url);
    }
   
}
